// 主题配置
export const themes = {
  light: {
    id: 'light',
    name: '亮色模式',
    colors: {
      // 背景色
      bgPrimary: 'bg-white',
      bgSecondary: 'bg-gray-50',
      bgTertiary: 'bg-gray-100',
      bgCard: 'bg-white',
      bgInput: 'bg-white',
      bgHover: 'bg-gray-100',
      
      // 文字色
      textPrimary: 'text-gray-800',
      textSecondary: 'text-gray-600',
      textTertiary: 'text-gray-500',
      textPlaceholder: 'text-gray-400',
      
      // 边框色
      border: 'border-gray-200',
      borderHover: 'border-gray-300',
      
      // 强调色
      accent: 'text-green-600',
      accentBg: 'bg-green-600',
      accentHover: 'hover:bg-green-700',
      
      // 成功/警告/错误
      success: 'bg-green-100 text-green-700',
      warning: 'bg-yellow-100 text-yellow-700',
      error: 'bg-red-100 text-red-700'
    }
  },
  dark: {
    id: 'dark',
    name: '暗色模式',
    colors: {
      // 背景色
      bgPrimary: 'bg-gray-900',
      bgSecondary: 'bg-gray-800',
      bgTertiary: 'bg-gray-700',
      bgCard: 'bg-gray-800',
      bgInput: 'bg-gray-700',
      bgHover: 'bg-gray-700',
      
      // 文字色
      textPrimary: 'text-white',
      textSecondary: 'text-gray-300',
      textTertiary: 'text-gray-400',
      textPlaceholder: 'text-gray-500',
      
      // 边框色
      border: 'border-gray-700',
      borderHover: 'border-gray-600',
      
      // 强调色
      accent: 'text-green-400',
      accentBg: 'bg-green-600',
      accentHover: 'hover:bg-green-700',
      
      // 成功/警告/错误
      success: 'bg-green-500/20 text-green-400',
      warning: 'bg-yellow-500/20 text-yellow-400',
      error: 'bg-red-500/20 text-red-400'
    }
  }
}

// 主题模式类型
export const themeModes = {
  LIGHT: 'light',
  DARK: 'dark',
  SYSTEM: 'system' // 跟随系统
}

// 获取主题配置
export function getThemeConfig(mode) {
  return themes[mode] || themes.light
}

// 获取主题颜色类
export function getThemeColor(colorKey, mode) {
  const theme = getThemeConfig(mode)
  return theme.colors[colorKey] || ''
}

// 获取当前主题模式
export function getSystemTheme() {
  if (typeof window !== 'undefined' && window.matchMedia) {
    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
  }
  return 'light'
}
